const Fields = [
  {
    label: "Title",
    name: "title",
    type: "text",
    required: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "",
    name: "forUI",
    forUI: true,
  },
  {
    label: "Phone Number ID",
    name: "phoneNumberId",
    type: "text",
    required: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Number",
    name: "number",
    type: "text",
    required: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Verify Token",
    name: "verifyToken",
    required: true,
    textarea: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Access Token",
    name: "accessToken",
    required: true,
    textarea: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Initial Date",
    name: "initialDate",
    date: true,
    required: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Expiry Date",
    name: "expiryDate",
    date: true,
    required: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Status",
    name: "isActive",
    switch: true,
  },
];
const ViewFields = [
  { label: "Title", name: "title" },
  {
    label: "Account Status",
    name: "isActive",
  },
  { label: "Verify Token", name: "verifyToken" },
  { label: "Access Token", name: "accessToken" },
  {
    label: "Initial Date",
    name: "initialDate",
    date: true,
  },
  {
    label: "Expiry Date",
    name: "expiryDate",
    date: true,
  },
];

const NumberFields = [
  {
    label: "Number",
    name: "number",
    type: "text",
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Phone Number Id",
    name: "phoneNumberId",
    type: "text",
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "isActive",
    label: "Number Status",
    switch: true,
    validationType: "boolean",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
];
export { Fields, ViewFields, NumberFields };
